import React from 'react';

import { CompensationLinks, compensationLink } from './constants';

import styles from './styles.module.scss';

export const CompensationLink: React.FC<components.CompensationLink> = ({ status }) => {
  let content;
  if (CompensationLinks.includes(status)) {
    content = (
      <div className={styles.rootComponent}>
        <a className={styles.anchor} href={compensationLink} target="_blank" rel="noreferrer">
          Compensation for delays &gt;
        </a>
      </div>
    );
  }
  return content;
};
